import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Card, Input } from 'antd';
import { Formik } from 'formik';
import React from 'react';
import { API_KEY } from '../../constants';
import { useLazyQuery } from '@apollo/react-hooks';
import axios from 'axios';
import gql from 'graphql-tag';
import firebase from 'firebase/app';
import LoadingSpinner from '../../utils/LoadingSpinner';
import { notificationService } from '../ui/NotificationService';

export const GET_COLEGIO_BY_PASSWORD = gql`
	query GetColegio($password: String!) {
		colegios(where: { password: { _eq: $password } }) {
			key
			firebase_uid
			nombre
		}
	}
`;

const SignInColegio = () => {
	const [isLoading, setIsLoading] = React.useState(false);
	const [getEstudiante] = useLazyQuery(GET_COLEGIO_BY_PASSWORD, {
		onCompleted: ev => {
			if (ev.colegios.length > 0) {
				axios
					.post(`${API_KEY}/auth/signInColegio`, {
						login: {
							uid: ev.colegios[0].firebase_uid,
							hasuraKey: ev.colegios[0].key,
							tipoUsuario: 'colegio'
						}
					})
					.then(res => {
						firebase
							.auth()
							.signInWithCustomToken(res.data.token)
							.catch(function(error: any) {
								console.log(error);
								setIsLoading(false);
								return error;
							});
					});
			} else {
				setIsLoading(false);
				notificationService({ error: true }, 'Contraseña incorrecta, intenta de nuevo');
			}
		}
	});

	if (isLoading) {
		return <LoadingSpinner type="pacman"></LoadingSpinner>;
	}

	return (
		<Card title="Sign in" style={{ width: '100%' }}>
			<Formik
				initialValues={{ password: '' }}
				onSubmit={(values, actions) => {
					setIsLoading(true);
					getEstudiante({ variables: { password: values.password } });
				}}
				render={(props: any) => (
					<Form layout="vertical">
						<Form.Item label="Ingresa tu clave secreta">
							<Input
								type="password"
								name="password"
								onChange={props.handleChange}
								onBlur={props.handleBlur}
								value={props.values.password}
							/>
						</Form.Item>
						<Form.Item>
							<Button type="primary" onClick={props.handleSubmit} color="primary">
								Submit
							</Button>
						</Form.Item>
					</Form>
				)}
			/>
		</Card>
	);
};

export default SignInColegio;
